<div class="player">
    <div class="c-video">
        <div #brightcoveContainer></div>
    </div>
</div>